import { ResourceCostCodeCostTypeBase } from './base/resource-cost-code-cost-type-base';

export class ResourceCostCodeCostType extends ResourceCostCodeCostTypeBase { }